import React from 'react';
import classNames from 'classnames';

export interface TagProps {
  children?: React.ReactNode | string;
  className?: string;
  id?: string;
}

const Tag = ({ children, className, id }: TagProps): JSX.Element => {
  const tagClasses = classNames('usa-tag', className);

  return (
    <span id={id} className={tagClasses} data-testid="uswds-react-tag">
      {children}
    </span>
  );
};

export default Tag;
